    let flag = true;
    function showPasswordFormOverlay(flag) {
        const passwordForm = document.querySelector('.password .password__form');
        const passwordOverlay = document.querySelector('.password .form-overlay');
        const passwordOverlayOpen = document.querySelector('.password .password__open');
        const passwordOverlayClose = document.querySelector('.password .password__close');

        if (passwordForm && passwordOverlay) {
            passwordOverlayOpen.addEventListener('click', () => {
                passwordOverlay.classList.add('form-overlay--visible');
                passwordForm.classList.add('password__form--visible');
            });
            passwordOverlayClose.addEventListener('click', () => {
                passwordOverlay.classList.remove('form-overlay--visible');
                passwordForm.classList.remove('password__form--visible');
            });
            passwordOverlay.addEventListener('click', (e) => {
                if (e.target != passwordForm) {
                    passwordOverlay.classList.remove('form-overlay--visible');
                    passwordForm.classList.remove('password__form--visible');
                }
            });
            if (flag == false) {
                passwordOverlayOpen.click();
            }
        }
    }
    showPasswordFormOverlay(flag);


	$(".storefront-password-form").submit(function () {

		let url = "/password"; 
        let formData = $(".storefront-password-form").serialize();
		$.ajax({
			type: "POST",
			url: url,
			data: formData, 
			complete: function (data) {
                checkUrl(`/password?${formData}`)
			}
		});

		return false; 
	});
    function checkUrl(url){
        $.ajax({
			type: "GET",
			url: url,
			data: {}, 
			complete: function (data) {		
                let flag = false;
                $('.password').html($('.password', data.responseText).html())
                showPasswordFormOverlay(flag);
                document.querySelector('.storefront-password-form .form-el__field').classList.add('validation-error');
                history.pushState(
                {
                    page: url,
                },
                url,
                url
            )
			}
		});
    }